import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { WidgetHelperService } from '../widget-helper.service';

@Component({
  selector: 'visual-map',
  templateUrl: './visual-map.component.html',
  styleUrls: ['./visual-map.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VisualMapComponent implements OnInit {
  @Input('graphData') graphData: any;
  widgetId = "";
  deviceImage = "";
  originX = 0;
  originY = 0;
  imgW;
  imgH;
  base64Img;
  constructor(private widgetHelperService: WidgetHelperService) { }

  ngOnInit() {
    //set id
    this.widgetId = this.graphData.udf.widgetId;
    if(this.graphData.udf.visualConfig && this.graphData.udf.visualConfig.deviceImage){
      this.deviceImage = "https://xpandretail-assets.s3.amazonaws.com/" + this.graphData.udf.visualConfig.deviceImage;
    }

    //filter data by specifi date
    this.graphData = this.widgetHelperService.filterData(this.graphData);
  }

  ngOnChanges(){
    console.log('Inside visual');
    this.graphData = this.widgetHelperService.filterData(this.graphData);
    this.prepareRaphael();
  }

  ngAfterViewInit(){
    if(this.deviceImage == ""){
      //if image is not avaialbe
      //onload event will not hit below function
      //initiated here
      this.prepareVisual();
    }
  }

  prepareVisual(){
    //get image for height and width
    let img = <HTMLImageElement>document.querySelector("#visual-container-"+ this.widgetId +" img");
    if(img){

    }
    if(!img){
      //return if image not found
      return ;
    }
    // let w = img.clientWidth;
    // let h = img.clientHeight;
    this.imgW = img.clientWidth;
    this.imgH = img.clientHeight;

    img.remove();

    //if image is not avaialble apply default w and h
    if(this.deviceImage == ""){
      this.imgW = 400;
      this.imgH = 400;
    }

    //render base64 image to make 
    //self contained svg so we can show in pdf
    //let canvas2 = document.createElement('canvas');
    let canvas2 = <HTMLCanvasElement> document.querySelector("#visual-container-"+ this.widgetId +" canvas");
    canvas2.height = this.imgH //h;
    canvas2.width = this.imgW//w;
    canvas2.getContext("2d").drawImage(img, 0, 0, this.imgW, this.imgH, 0, 0, this.imgW, this.imgH);
    this.base64Img = canvas2.toDataURL();
    canvas2.remove();

    //if multi sensor convert mm to px
    this.renderMultisensorLogic(this.imgW, this.imgH);
    this.prepareRaphael();
    
  }


  prepareRaphael(){
    if(this.imgW && this.imgH){
    //take visual container
    let container = document.getElementById('visual-container-' + this.widgetId);
    let svgContainer = Array.from(container.querySelectorAll('svg'));
    svgContainer.forEach(v => {
      v.remove();
    })
      //Will be used for rerendering 
    // if(container.querySelectorAll('svg').length > 0 && container.lastElementChild){
    //     container.lastElementChild.remove();
    // }

    //apply css to take it center
    container.style.width = this.imgW + "px";
    container.style.height = this.imgH + "px";
    container.style.margin = "0 auto";


    //initial raphael to draw on image
    var paper = new Raphael(container, this.imgW , this.imgH);
    let border =  paper.rect(0,0,this.imgW,this.imgH);
      border.attr({
        'stroke': '#000',
        'stroke-width': '2'
      });

    if(this.deviceImage && this.base64Img){
      paper.image(this.base64Img, 0, 0, this.imgW ,this.imgH);
    }else{
      paper.text(this.imgW/2, this.imgH/2, "Image is not uploaded in device").attr({fill: '#ff0000', 'font-size': '16px', 'font-weight': 600});
    }

    //set origin in green circle
    var origin = paper.circle(this.originX + 5, this.originY + 5, 5);
    origin.attr({fill: 'rgba(73, 126, 1, 1)', 'stroke-width': 0});


    if(this.graphData.fetchDataFor == "startStopMap"){
      this.renderStartStop(paper);
    }else if(this.graphData.fetchDataFor == "pathTracking"){
      this.renderPathTracking(paper);
    }else if(this.graphData.fetchDataFor == "heatMap"){
      this.renderHeatMap(this.imgW, this.imgH, paper);
    }else if(this.graphData.fetchDataFor == "heightMap"){
      this.renderHeight(paper);
    }
  }
  }

  renderStartStop(paper){
    //defined person id and day so can 
    //put start and stop dots basis on this
    //if personid or date changes it will create new start stop
    let personId = 0;
    let day = 0;


    this.graphData.dataFilter.forEach(df => {
      df.data.forEach((data , i) => {

        //conver to js date
        let cday = new Date(data.dateFrom).getDay();

        //if person id or day is not equal
        if(data.value.id != personId || day != cday){

          //start circle
          var start = paper.circle(data.value.x, data.value.y, 3);
          start.attr({fill: 'rgba(73, 126, 1, 0.5)', 'stroke-width': 0});

          if(i > 1){
            //if start point is not same as end point then only it 
            //create end point
            let endData1 = df.data[i - 1];
            let endData2 = df.data[i - 2];
            if(endData1.value.id == endData2.value.id){
              var end = paper.circle(endData1.value.x, endData1.value.y, 3);
              end.attr({fill: 'rgba(255, 34, 34, 0.3)', 'stroke-width': 0});
            }
          }

          //replace for next checking
          day = cday;
          personId = data.value.id;
        }
      })
    })

  }

  
  renderPathTracking(paper){
    //draw a path or line if personId or day changes
    let personId = 0;
    let day = 0;
    let path = "";


    this.graphData.dataFilter.forEach(df => {
      df.data.forEach((data , i) => {

        //l 50, 20 draw a line
        if(i != 0){
          let pData = df.data[i - 1];
          path += " l " + (pData.value.x - data.value.x) + " " + (pData.value.y - data.value.y);
        }

        //if day or person id change stop creating above
        //line points and start with new one
        let cday = new Date(data.dateFrom).getDay();
        if(data.value.id != personId || day != cday){

          //draw previously collected data and
          if(i != 0){
            let p = paper.path(path);
            p.attr({stroke: 'rgba(141, 0, 232, 0.5)', 'stroke-width': 3});
          }

          //start with new path or line
          path = "M " + data.value.x + " " + data.value.y + " ";
          

          //replace for next checking
          day = cday;
          personId = data.value.id;
        }
      })
    })
  }


  renderHeatMap(w, h, paper){
    var heatmapInstance = h337.create({
      // only container is required, the rest will be defaults
      container: document.getElementById('visual-container-' + this.widgetId)
    });

    // now generate some random data
    var points = [];
    var max = 0;
    var len = 300;

    //calculate max
    let pointsOnImage = {};
    let i = 0, j = 0;
    while(i != w){

      j = 0;
      while(j != h){
        pointsOnImage[i+ "-" +j] = 0;

        j += 10;

        if(j > h){
          j = h;
        }
      }

      //increase by 10px
      i += 10;

      //replace if i or j becomes greater  to repective dimension
      if(i > w){
        i = w;
      }
    }

    let personId = 0;
    let day = 0;
    this.graphData.dataFilter.forEach(df => {
      df.data.forEach((data , i) => {
        let x = Math.floor(data.value.x/10)*10;
        let y = Math.floor(data.value.y/10)*10;
        if(pointsOnImage[x+"-"+y] || pointsOnImage[x+"-"+y] == 0){
          pointsOnImage[x+"-"+y]++;
          max = Math.max(max, pointsOnImage[x+"-"+y]);
        }
        var point = {
          x: data.value.x,
          y: data.value.y,
          value: 1,
          // radius configuration on point basis
          radius: 5
        };
        points.push(point);
      })
    })

    //doing this because if set it on 
    //actual max it will not draw proper heat map
    //low value will not be visible
    max = Math.round(max/6);

    // heatmap data format
    var data = { 
      max: max, 
      data: points 
    };
    // if you have a set of datapoints always use setData instead of addData
    // for data initialization
    heatmapInstance.setData(data);

    //draw max point 
    paper.text(55,15, "Max = " + max).attr({fill: "#fff"});
  }

  
  renderHeight(paper){
    let heightMeasurement = [{
      color: "rgba(1,1,137,0.5)",
      min: 0,
      max: 90
    },{
      color: "rgba(1,64,232,0.5)",
      min: 91,
      max: 110
    },{
      color: "rgba(1,182,254,0.5)",
      min: 111,
      max: 130
    },{
      color: "rgba(1,254,254,0.5)",
      min: 131,
      max: 150
    },{
      color: "rgba(139,252,1,0.5)",
      min: 151,
      max: 170
    },{
      color: "rgba(254,201,1,0.5)",
      min: 171,
      max: 190
    },{
      color: "rgba(254,131,1,0.5)",
      min: 191,
      max: 210
    },{
      color: "rgba(254,37,1,0.5)",
      min: 210,
      max: 300
    }];

    //set box color indication on top of the image
    let w = this.imgW;
    let h = this.imgH;
    paper.text( 40 , h-32 ,"cm").attr({fill: "#fff", 'font-size': "13px"});
    heightMeasurement.forEach((hm, i) => {
      paper.rect(((i == 0? 10 : 35) * (i)) + 50 , h-25 , 35, 15).attr({fill: hm.color, 'stroke-width': 0});
      paper.text(((i == 0? 10 : 35) * (i)) + 50 + 35/2, h -32 , 
      (   (i == 0 ? "<= " : "") + (i == 7 ? ">= " : "") + hm.max   ))
      .attr({fill: "#fff", 'font-size': "13px"});
    });

    //create rectangle box basis on height 
    //and fill color according to height
    let personId = 0;
    let day = 0;
    this.graphData.dataFilter.forEach(df => {
      df.data.forEach((data , i) => {

        //convert mm to cm
        data.value.height = data.value.height/10;
        heightMeasurement.forEach((hm) => {
          if(data.value && data.value.height && data.value.height >= hm.min && data.value.height <= hm.max){
            var rect = paper.rect(data.value.x - 2.5, data.value.y, 10, 10);
            rect.attr({fill: hm.color, 'stroke-width': 0});
          }
        });
      })
    })

  }

  //convert data to px if it is multisensor
  renderMultisensorLogic(imgW, imgH){

    //if not a multisensor
    if(!this.graphData.udf || !this.graphData.udf.visualConfig || this.graphData.udf.visualConfig.isMultiSensor != 1){
      return true;
    }

    //in a case of multi sensor it will return us area in 
    //mili meter we have to convert it in pixel to show on image
    let perX = (this.graphData.udf.visualConfig.width? this.graphData.udf.visualConfig.width: 1)/imgW;
    let perY = (this.graphData.udf.visualConfig.height? this.graphData.udf.visualConfig.height: 1)/imgH;
    
    if(perX <= 1 && perY <= 1){
      //no alteration needed
      return true;
    }

    //converting mm to px
    this.originX = Math.abs((this.graphData.udf.visualConfig.originX? this.graphData.udf.visualConfig.originX: 0)/perX);
    this.originY = Math.abs((this.graphData.udf.visualConfig.originY? this.graphData.udf.visualConfig.originY: 0)/perY);

    this.graphData.dataFilter.forEach((df, j) => {
      df.data.forEach((data , i) => {

        //converting mm to px
        this.graphData.dataFilter[j].data[i].value.x = (data.value.x / perX) + this.originX;
        this.graphData.dataFilter[j].data[i].value.y = (data.value.y / perY) + this.originY;

      })
    })

    return true;
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/visual-map/visual-map.component.ts